import React from 'react';
import { bool, object, elementType, func, string } from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_right } from '@fiverr-private/icons';
import { ParameterizedText } from '../CarouselHeader/ParameterizedText';

import './style.scss';
import { getCarouselHref } from './utils';

export const CarouselLink = ({
    urlData,
    className,
    dataEnrichment = {},
    showMore = false,
    icon = l_chevron_right,
    onClick = Function.prototype,
}) => {
    const href = getCarouselHref(urlData, dataEnrichment);

    const typeClasses = showMore ? ['show-more', 'tbody-5'] : 'text-display-4';
    const classNames = classnames('carousel-link', typeClasses, className);

    return (
        <a target="_blank" href={href} className={classNames} onClick={onClick}>
            <ParameterizedText section={urlData} />
            {showMore && <Icon className="link-icon">{icon}</Icon>}
        </a>
    );
};

CarouselLink.propTypes = {
    urlData: object,
    className: string,
    dataEnrichment: object,
    showMore: bool,
    icon: elementType,
    onClick: func,
};
